var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _g2, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g4, _path27, _g5, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleSystemBgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 452,
    viewBox: "0 0 1000 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_152914)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476.35 129.99C488.5 129.99 500.64 132.16 511.53 136.5L691.97 208.4C713.73 217.08 727.15 233.11 727.15 250.46V394.28C727.15 411.63 713.73 427.66 691.97 436.34L511.53 508.24C500.64 512.58 488.5 514.75 476.35 514.75C464.2 514.75 452.06 512.58 441.17 508.24L260.73 436.34C238.97 427.66 225.55 411.63 225.55 394.28V250.46C225.55 233.11 238.97 217.08 260.73 208.4L441.17 136.5C452.06 132.16 464.2 129.99 476.35 129.99Z",
    fill: "url(#paint0_radial_4_152914)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M689.52 188H616.72V184H689.52C700.09 184 708.7 175.4 708.7 164.82V109.65C708.7 96.8702 719.1 86.4702 731.88 86.4702H919.73V90.4702H731.88C721.31 90.4702 712.7 99.0702 712.7 109.65V164.82C712.7 177.6 702.3 188 689.52 188Z",
    fill: "url(#paint1_linear_4_152914)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.28 303.04H783.98C771.44 303.04 761.24 292.84 761.24 280.3V257.4C761.24 247.07 752.83 238.66 742.5 238.66H613.14V234.66H742.5C755.04 234.66 765.24 244.86 765.24 257.4V280.3C765.24 290.63 773.65 299.04 783.98 299.04H1000.28V303.04Z",
    fill: "url(#paint2_linear_4_152914)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M918.75 213.11H616.72V217.11H918.75V213.11Z",
    fill: "url(#paint3_linear_4_152914)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M918.75 163.05H616.72V167.05H918.75V163.05Z",
    fill: "url(#paint4_linear_4_152914)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.38 188.68H0V184.68H207.38C216.3 184.68 223.55 177.42 223.55 168.51V150.03C223.55 138.91 232.6 129.86 243.72 129.86H321.74V133.86H243.72C234.8 133.86 227.55 141.12 227.55 150.03V168.51C227.55 179.63 218.5 188.68 207.38 188.68Z",
    fill: "url(#paint5_linear_4_152914)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321 149H0V153H321V149Z",
    fill: "url(#paint6_linear_4_152914)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M320 217H156.242C144.839 217 135.559 207.962 135.559 196.856V115.144C135.559 106.235 128.115 98.9948 118.978 98.9948H0V95H118.968C130.371 95 139.651 104.038 139.651 115.144V196.856C139.651 205.765 147.095 213.005 156.232 213.005H319.99V217H320Z",
    fill: "url(#paint7_linear_4_152914)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.08 280.12H0V276.12H67.08C77.54 276.12 86.05 267.61 86.05 257.15C86.05 244.48 96.35 234.18 109.02 234.18H320.67V238.18H109.02C98.56 238.18 90.05 246.69 90.05 257.15C90.05 269.82 79.75 280.12 67.08 280.12Z",
    fill: "url(#paint8_linear_4_152914)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M639.94 262.9C639.94 262.99 639.92 263.09 639.91 263.18C639.85 263.8 639.76 264.41 639.65 265.02C639.64 265.1 639.62 265.17 639.6 265.25C639.48 265.87 639.33 266.49 639.16 267.1C639.16 267.12 639.15 267.15 639.14 267.17C638.97 267.77 638.76 268.37 638.54 268.96C638.49 269.08 638.45 269.2 638.4 269.32C638.18 269.89 637.94 270.45 637.67 271C637.56 271.22 637.44 271.44 637.33 271.67C637.13 272.06 636.93 272.45 636.7 272.84C636.56 273.08 636.41 273.32 636.26 273.56C636.04 273.92 635.81 274.28 635.57 274.63C635.4 274.88 635.23 275.12 635.05 275.36C634.8 275.7 634.55 276.04 634.29 276.37C634.1 276.61 633.91 276.85 633.71 277.08C633.41 277.44 633.09 277.8 632.77 278.15C632.62 278.31 632.48 278.47 632.33 278.63C631.85 279.14 631.35 279.63 630.83 280.12C630.82 280.12 630.81 280.14 630.8 280.15C630.27 280.64 629.7 281.12 629.13 281.59C628.95 281.73 628.77 281.87 628.59 282.02C628.17 282.35 627.74 282.68 627.3 283C627.09 283.15 626.89 283.3 626.68 283.44C626.2 283.77 625.71 284.1 625.21 284.42C625.04 284.53 624.88 284.63 624.72 284.74C624.05 285.15 623.37 285.55 622.66 285.94C622.51 286.02 622.35 286.1 622.19 286.19C621.61 286.5 621.02 286.8 620.42 287.09C620.24 287.17 620.07 287.26 619.89 287.34C619.15 287.68 618.41 288.02 617.64 288.33L502.78 335.22C500.89 335.99 498.94 336.66 496.94 337.22C494.71 337.85 492.27 338.4 489.95 338.76L490.05 362.25C492.37 361.89 494.7 361.39 496.93 360.76C498.93 360.2 500.88 359.53 502.77 358.76L617.63 311.87C618.4 311.56 619.15 311.22 619.88 310.88C620.06 310.8 620.24 310.71 620.41 310.63C620.58 310.55 620.76 310.47 620.92 310.39C621.35 310.18 621.76 309.95 622.18 309.73C622.34 309.65 622.5 309.57 622.65 309.48C623.35 309.09 624.04 308.69 624.71 308.28C624.88 308.18 625.04 308.07 625.2 307.96C625.7 307.64 626.19 307.32 626.67 306.98C626.88 306.83 627.09 306.69 627.29 306.54C627.73 306.22 628.16 305.89 628.58 305.56C628.76 305.42 628.94 305.28 629.12 305.14C629.7 304.67 630.26 304.19 630.79 303.69L630.81 303.67C631.34 303.18 631.83 302.68 632.32 302.18C632.47 302.02 632.62 301.86 632.76 301.7C632.95 301.49 633.16 301.28 633.35 301.07C633.47 300.93 633.58 300.78 633.7 300.64C633.9 300.4 634.09 300.17 634.28 299.93C634.54 299.6 634.8 299.26 635.04 298.92C635.22 298.68 635.39 298.44 635.56 298.19C635.8 297.84 636.03 297.48 636.25 297.12C636.4 296.88 636.55 296.64 636.69 296.4C636.91 296.01 637.12 295.62 637.32 295.23C637.43 295.01 637.56 294.79 637.66 294.56C637.68 294.51 637.71 294.46 637.74 294.41C637.98 293.9 638.19 293.39 638.39 292.88C638.44 292.76 638.48 292.64 638.53 292.52C638.75 291.93 638.96 291.33 639.13 290.72C639.13 290.7 639.14 290.67 639.15 290.65C639.26 290.27 639.36 289.88 639.45 289.49C639.5 289.26 639.55 289.03 639.59 288.8C639.6 288.72 639.62 288.65 639.64 288.57C639.75 287.96 639.84 287.35 639.9 286.73C639.9 286.64 639.92 286.54 639.93 286.45C639.97 285.98 640 285.52 640.02 285.04C640.02 284.84 640.02 284.65 640.02 284.45V260.91C640.02 261.58 639.99 262.24 639.93 262.9H639.94Z",
    fill: "url(#paint9_linear_4_152914)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M483.84 339.37C482.69 339.43 481.54 339.46 480.38 339.46C479.48 339.46 478.58 339.44 477.68 339.4C475.52 339.31 473.38 339.11 471.25 338.79C468.76 338.42 466.3 337.9 463.9 337.23C461.88 336.66 459.9 335.99 457.99 335.21L343.13 288.32C329.28 282.66 320.74 272.21 320.74 260.89V284.43C320.74 295.74 329.28 306.2 343.13 311.86L457.99 358.75C459.91 359.53 461.88 360.21 463.9 360.77C466.3 361.44 468.76 361.96 471.25 362.33C473.37 362.64 475.52 362.85 477.68 362.94C478.58 362.98 479.48 363 480.38 363C481.53 363 482.69 362.97 483.84 362.91C485.94 362.8 488.03 362.58 490.1 362.25V338.71C488.03 339.03 485.94 339.25 483.84 339.37Z",
    fill: "url(#paint10_linear_4_152914)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.39 91.8101C488.12 91.8101 495.85 93.2201 502.78 96.0501L617.64 142.94C631.49 148.6 640.03 159.05 640.03 170.37V264.16C640.03 275.47 631.49 285.93 617.64 291.59L502.78 338.48C495.85 341.31 488.12 342.72 480.39 342.72C472.66 342.72 464.93 341.31 458 338.48L343.14 291.59C329.29 285.93 320.75 275.48 320.75 264.16V170.37C320.75 159.06 329.29 148.6 343.14 142.94L458 96.0501C464.93 93.2201 472.66 91.8101 480.39 91.8101Z",
    fill: "url(#paint11_linear_4_152914)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M480.39 343.46C479.48 343.46 478.57 343.44 477.66 343.4C475.48 343.31 473.29 343.1 471.15 342.79C468.62 342.42 466.11 341.89 463.71 341.21C461.65 340.63 459.64 339.94 457.72 339.16L342.86 292.27C328.76 286.51 320 275.73 320 264.15H321.5C321.5 275.11 329.9 285.36 343.43 290.88L458.29 337.77C460.16 338.53 462.12 339.2 464.12 339.76C466.46 340.42 468.91 340.93 471.38 341.3C473.46 341.61 475.6 341.81 477.73 341.9C479.75 341.99 481.79 341.97 483.81 341.86C485.88 341.75 487.96 341.53 489.99 341.21C492.29 340.85 494.56 340.35 496.74 339.74C498.72 339.18 500.66 338.52 502.5 337.77L617.36 290.88C618.12 290.57 618.85 290.24 619.58 289.9L620.11 289.65C620.7 289.36 621.28 289.07 621.86 288.76L622.32 288.52C623.01 288.14 623.69 287.75 624.34 287.34L624.83 287.03C625.32 286.72 625.8 286.4 626.27 286.07C626.48 285.93 626.68 285.78 626.88 285.63C627.31 285.32 627.73 285 628.14 284.67L628.3 284.54C628.42 284.44 628.55 284.35 628.67 284.25C629.23 283.79 629.78 283.32 630.31 282.83C630.85 282.33 631.34 281.84 631.81 281.35C631.91 281.24 632.01 281.14 632.11 281.03L632.25 280.88C632.57 280.54 632.87 280.19 633.17 279.84C633.36 279.61 633.55 279.38 633.74 279.14C634 278.82 634.24 278.49 634.49 278.15C634.66 277.91 634.83 277.68 634.99 277.44C635.22 277.1 635.44 276.75 635.66 276.4L635.77 276.23C635.88 276.05 635.99 275.88 636.09 275.7C636.31 275.33 636.5 274.94 636.7 274.56L636.83 274.32C636.9 274.19 636.97 274.05 637.04 273.92C637.29 273.39 637.53 272.84 637.75 272.29L637.87 271.98C638.13 271.28 638.32 270.72 638.47 270.2C638.65 269.56 638.79 268.98 638.91 268.34L638.96 268.12C639.06 267.56 639.15 266.96 639.21 266.34L639.24 266.07C639.3 265.39 639.33 264.76 639.33 264.15H640.83C640.83 264.8 640.8 265.48 640.73 266.21L640.7 266.5C640.63 267.16 640.54 267.8 640.43 268.4L640.4 268.54C640.25 269.31 640.1 269.94 639.93 270.54C639.75 271.18 639.55 271.77 639.29 272.46L639.15 272.84C638.92 273.43 638.67 274.01 638.4 274.57C638.33 274.72 638.25 274.88 638.17 275.03L638.05 275.26C637.84 275.66 637.63 276.07 637.41 276.46C637.3 276.65 637.18 276.84 637.06 277.04L636.96 277.21C636.73 277.58 636.5 277.94 636.25 278.31C636.08 278.56 635.9 278.8 635.73 279.05C635.47 279.41 635.21 279.75 634.94 280.09C634.75 280.34 634.55 280.58 634.34 280.82C634.03 281.19 633.71 281.55 633.38 281.91L633.25 282.05C633.14 282.17 633.04 282.28 632.93 282.4C632.39 282.96 631.89 283.46 631.39 283.92C630.86 284.41 630.31 284.89 629.66 285.42C629.53 285.53 629.4 285.63 629.27 285.73L629.11 285.85C628.68 286.19 628.25 286.52 627.8 286.84C627.59 286.99 627.38 287.14 627.17 287.29C626.68 287.63 626.19 287.96 625.68 288.28L625.18 288.6C624.5 289.02 623.8 289.43 623.09 289.82L622.61 290.07C622.02 290.38 621.42 290.69 620.81 290.99L620.27 291.25C619.52 291.6 618.77 291.94 617.98 292.26L503.12 339.15C501.22 339.92 499.23 340.61 497.2 341.18C494.96 341.81 492.63 342.32 490.27 342.69C488.19 343.02 486.06 343.24 483.94 343.36C482.78 343.42 481.6 343.46 480.44 343.46H480.39Z",
    fill: "url(#paint12_linear_4_152914)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M480.39 99.0698C487.77 99.0698 495.14 100.39 501.76 103.02L611.35 146.69C624.56 151.96 632.72 161.7 632.72 172.23V259.58C632.72 270.12 624.57 279.85 611.35 285.12L501.76 328.79C495.15 331.43 487.77 332.74 480.39 332.74C473.01 332.74 465.64 331.42 459.02 328.79L349.43 285.12C336.22 279.85 328.06 270.11 328.06 259.58V172.23C328.06 161.69 336.21 151.96 349.43 146.69L459.02 103.02C465.63 100.38 473.01 99.0698 480.39 99.0698Z",
    fill: "#142F38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M639.94 216.99C639.94 217.08 639.92 217.18 639.91 217.27C639.85 217.89 639.76 218.5 639.65 219.11C639.64 219.19 639.62 219.26 639.6 219.34C639.48 219.96 639.33 220.58 639.16 221.19C639.16 221.21 639.15 221.24 639.14 221.26C638.97 221.86 638.76 222.46 638.54 223.05C638.49 223.17 638.45 223.29 638.4 223.41C638.18 223.98 637.94 224.54 637.67 225.09C637.56 225.31 637.44 225.53 637.33 225.76C637.13 226.15 636.93 226.54 636.7 226.93C636.56 227.17 636.41 227.41 636.26 227.65C636.04 228.01 635.81 228.37 635.57 228.72C635.4 228.97 635.23 229.21 635.05 229.45C634.8 229.79 634.55 230.13 634.29 230.46C634.1 230.7 633.91 230.94 633.71 231.17C633.41 231.53 633.09 231.89 632.77 232.24C632.62 232.4 632.48 232.56 632.33 232.72C631.85 233.23 631.35 233.72 630.83 234.21C630.82 234.21 630.81 234.23 630.8 234.24C630.27 234.73 629.7 235.21 629.13 235.68C628.95 235.82 628.77 235.96 628.59 236.11C628.17 236.44 627.74 236.77 627.3 237.09C627.09 237.24 626.89 237.39 626.68 237.53C626.2 237.86 625.71 238.19 625.21 238.51C625.04 238.62 624.88 238.72 624.72 238.83C624.05 239.24 623.37 239.64 622.66 240.03C622.51 240.11 622.35 240.19 622.19 240.28C621.61 240.59 621.02 240.89 620.42 241.18C620.24 241.26 620.07 241.35 619.89 241.43C619.15 241.77 618.41 242.11 617.64 242.42L502.78 289.31C500.89 290.08 498.94 290.75 496.94 291.31C494.71 291.94 492.24 292.44 489.92 292.8L490.03 316.35C492.35 315.99 494.7 315.48 496.93 314.85C498.93 314.29 500.88 313.62 502.77 312.85L617.63 265.96C618.4 265.65 619.15 265.31 619.88 264.97C620.06 264.89 620.24 264.8 620.41 264.72C620.58 264.64 620.76 264.56 620.92 264.48C621.35 264.27 621.76 264.04 622.18 263.82C622.34 263.74 622.5 263.66 622.65 263.57C623.35 263.18 624.04 262.78 624.71 262.37C624.88 262.27 625.04 262.16 625.2 262.05C625.7 261.73 626.19 261.41 626.67 261.07C626.88 260.92 627.09 260.78 627.29 260.63C627.73 260.31 628.16 259.98 628.58 259.65C628.76 259.51 628.94 259.37 629.12 259.23C629.7 258.76 630.26 258.28 630.79 257.78L630.81 257.76C631.34 257.27 631.83 256.77 632.32 256.27C632.47 256.11 632.62 255.95 632.76 255.79C632.95 255.58 633.16 255.37 633.35 255.16C633.47 255.02 633.58 254.87 633.7 254.73C633.9 254.49 634.09 254.26 634.28 254.02C634.54 253.69 634.8 253.35 635.04 253.01C635.22 252.77 635.39 252.53 635.56 252.28C635.8 251.93 636.03 251.57 636.25 251.21C636.4 250.97 636.55 250.73 636.69 250.49C636.91 250.1 637.12 249.71 637.32 249.32C637.43 249.1 637.56 248.88 637.66 248.65C637.68 248.6 637.71 248.55 637.74 248.5C637.98 247.99 638.19 247.48 638.39 246.97C638.44 246.85 638.48 246.73 638.53 246.61C638.75 246.02 638.96 245.42 639.13 244.81C639.13 244.79 639.14 244.76 639.15 244.74C639.26 244.36 639.36 243.97 639.45 243.58C639.5 243.35 639.55 243.12 639.59 242.89C639.6 242.81 639.62 242.74 639.64 242.66C639.75 242.05 639.84 241.44 639.9 240.82C639.9 240.73 639.92 240.63 639.93 240.54C639.97 240.07 640 239.61 640.02 239.13C640.02 238.93 640.02 238.74 640.02 238.54V215C640.02 215.67 639.99 216.33 639.93 216.99H639.94Z",
    fill: "url(#paint13_linear_4_152914)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M483.84 293.47C482.69 293.53 481.54 293.56 480.38 293.56C479.48 293.56 478.58 293.54 477.68 293.5C475.52 293.41 473.38 293.21 471.25 292.89C468.76 292.52 466.3 292 463.9 291.33C461.88 290.76 459.9 290.09 457.99 289.31L343.13 242.42C329.28 236.76 320.74 226.31 320.74 214.99V238.53C320.74 249.84 329.28 260.3 343.13 265.96L457.99 312.85C459.91 313.63 461.88 314.31 463.9 314.87C466.3 315.54 468.76 316.06 471.25 316.43C473.37 316.74 475.52 316.95 477.68 317.04C478.58 317.08 479.48 317.1 480.38 317.1C481.53 317.1 482.69 317.07 483.84 317.01C485.94 316.9 488.03 316.68 490.1 316.35V292.81C488.03 293.13 485.94 293.35 483.84 293.47Z",
    fill: "url(#paint14_linear_4_152914)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.39 45.9102C488.12 45.9102 495.85 47.3202 502.78 50.1502L617.64 97.0402C631.49 102.7 640.03 113.15 640.03 124.47V218.26C640.03 229.57 631.49 240.03 617.64 245.69L502.78 292.58C495.85 295.41 488.12 296.82 480.39 296.82C472.66 296.82 464.93 295.41 458 292.58L343.14 245.69C329.29 240.03 320.75 229.58 320.75 218.26V124.47C320.75 113.16 329.29 102.7 343.14 97.0402L458 50.1502C464.93 47.3202 472.66 45.9102 480.39 45.9102Z",
    fill: "url(#paint15_linear_4_152914)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M480.39 297.56C479.48 297.56 478.57 297.54 477.66 297.5C475.48 297.41 473.29 297.2 471.15 296.89C468.62 296.52 466.11 295.99 463.71 295.31C461.65 294.73 459.63 294.04 457.72 293.26L342.86 246.37C328.76 240.61 320 229.83 320 218.25H321.5C321.5 229.21 329.9 239.46 343.43 244.98L458.29 291.87C460.15 292.63 462.12 293.3 464.12 293.86C466.47 294.52 468.91 295.03 471.38 295.4C473.47 295.71 475.61 295.91 477.73 296C479.76 296.09 481.8 296.07 483.81 295.96C485.88 295.85 487.96 295.63 489.99 295.31C492.29 294.95 494.56 294.45 496.74 293.84C498.72 293.28 500.65 292.62 502.5 291.87L617.36 244.98C618.12 244.67 618.86 244.34 619.58 244L620.11 243.75C620.7 243.46 621.28 243.17 621.86 242.86L622.32 242.62C623.01 242.24 623.69 241.85 624.34 241.44L624.83 241.13C625.32 240.82 625.8 240.5 626.27 240.17C626.48 240.03 626.68 239.88 626.88 239.73C627.31 239.42 627.73 239.1 628.14 238.77L628.67 238.35C629.23 237.89 629.78 237.42 630.31 236.94C630.85 236.44 631.34 235.95 631.81 235.46L632.24 234.99C632.56 234.65 632.86 234.3 633.16 233.95C633.35 233.72 633.54 233.49 633.73 233.25C633.99 232.92 634.23 232.6 634.48 232.26C634.65 232.03 634.82 231.79 634.98 231.55C635.21 231.21 635.43 230.86 635.65 230.51L635.76 230.33C635.87 230.16 635.97 229.98 636.08 229.81C636.3 229.43 636.49 229.05 636.69 228.67L636.82 228.43C636.89 228.3 636.96 228.16 637.03 228.03C637.28 227.5 637.52 226.95 637.74 226.4L637.87 226.06C638.12 225.39 638.3 224.84 638.45 224.31C638.63 223.67 638.77 223.09 638.89 222.45L638.94 222.23C639.04 221.67 639.13 221.07 639.19 220.45L639.22 220.18C639.28 219.5 639.31 218.87 639.31 218.26H640.81C640.81 218.91 640.78 219.59 640.71 220.32L640.68 220.61C640.61 221.27 640.52 221.91 640.41 222.51L640.38 222.65C640.23 223.42 640.08 224.05 639.91 224.65C639.73 225.29 639.53 225.88 639.27 226.57L639.13 226.95C638.9 227.54 638.65 228.12 638.38 228.68C638.31 228.83 638.23 228.99 638.15 229.14L638.03 229.37C637.82 229.77 637.61 230.18 637.39 230.57C637.28 230.76 637.16 230.95 637.05 231.13L636.94 231.31C636.71 231.68 636.48 232.05 636.23 232.41C636.06 232.66 635.88 232.91 635.7 233.16C635.45 233.51 635.19 233.85 634.92 234.2C634.73 234.45 634.53 234.69 634.32 234.93C634.01 235.3 633.69 235.66 633.36 236.02L633.23 236.16C633.12 236.28 633.02 236.39 632.91 236.51C632.42 237.03 631.91 237.54 631.37 238.03C630.8 238.56 630.22 239.05 629.64 239.53C629.52 239.63 629.39 239.73 629.27 239.83L629.1 239.97C628.67 240.31 628.24 240.64 627.79 240.96C627.58 241.11 627.37 241.26 627.16 241.41C626.67 241.75 626.18 242.08 625.67 242.4L625.17 242.72C624.49 243.14 623.79 243.55 623.08 243.94L622.6 244.19C622.01 244.5 621.41 244.81 620.8 245.11L620.26 245.37C619.51 245.72 618.75 246.06 617.97 246.38L503.11 293.27C501.21 294.04 499.22 294.73 497.19 295.3C494.95 295.93 492.62 296.44 490.26 296.81C488.18 297.14 486.05 297.36 483.93 297.48C482.77 297.54 481.6 297.58 480.43 297.58L480.39 297.56Z",
    fill: "url(#paint16_linear_4_152914)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.39 54.5898C487.77 54.5898 495.14 55.9098 501.76 58.5398L611.35 102.21C624.56 107.48 632.72 117.22 632.72 127.75V215.1C632.72 225.64 624.57 235.37 611.35 240.64L501.76 284.31C495.15 286.95 487.77 288.26 480.39 288.26C473.01 288.26 465.64 286.94 459.02 284.31L349.43 240.64C336.22 235.37 328.06 225.63 328.06 215.1V127.75C328.06 117.21 336.21 107.48 349.43 102.21L459.02 58.5398C465.63 55.8998 473.01 54.5898 480.39 54.5898Z",
    fill: "#2D3770"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M639.94 171.09C639.94 171.18 639.92 171.28 639.91 171.37C639.85 171.99 639.76 172.6 639.65 173.21C639.64 173.29 639.62 173.36 639.6 173.44C639.48 174.06 639.33 174.68 639.16 175.29C639.16 175.31 639.15 175.34 639.14 175.36C638.97 175.96 638.76 176.56 638.54 177.15C638.49 177.27 638.45 177.39 638.4 177.51C638.18 178.08 637.94 178.64 637.67 179.19C637.56 179.41 637.44 179.63 637.33 179.86C637.13 180.25 636.93 180.64 636.7 181.03C636.56 181.27 636.41 181.51 636.26 181.75C636.04 182.11 635.81 182.47 635.57 182.82C635.4 183.07 635.23 183.31 635.05 183.55C634.8 183.89 634.55 184.23 634.29 184.56C634.1 184.8 633.91 185.04 633.71 185.27C633.41 185.63 633.09 185.99 632.77 186.34C632.62 186.5 632.48 186.66 632.33 186.82C631.85 187.33 631.35 187.82 630.83 188.31C630.82 188.31 630.81 188.33 630.8 188.34C630.27 188.83 629.7 189.31 629.13 189.78C628.95 189.92 628.77 190.06 628.59 190.21C628.17 190.54 627.74 190.87 627.3 191.19C627.09 191.34 626.89 191.49 626.68 191.63C626.2 191.96 625.71 192.29 625.21 192.61C625.04 192.72 624.88 192.82 624.72 192.93C624.05 193.34 623.37 193.74 622.66 194.13C622.51 194.21 622.35 194.29 622.19 194.38C621.61 194.69 621.02 194.99 620.42 195.28C620.24 195.37 620.07 195.45 619.89 195.53C619.15 195.87 618.41 196.21 617.64 196.52L502.78 243.41C500.89 244.18 498.94 244.85 496.94 245.41C494.71 246.04 492.3 246.61 489.99 246.98L490.07 270.45C492.39 270.09 494.71 269.58 496.94 268.96C498.94 268.4 500.89 267.73 502.78 266.96L617.64 220.07C618.41 219.76 619.16 219.42 619.89 219.08C620.07 219 620.25 218.91 620.42 218.83C620.59 218.75 620.77 218.67 620.93 218.59C621.36 218.38 621.77 218.15 622.19 217.93C622.35 217.85 622.51 217.77 622.66 217.68C623.36 217.29 624.05 216.89 624.72 216.48C624.89 216.38 625.05 216.27 625.21 216.16C625.71 215.84 626.2 215.52 626.68 215.18C626.89 215.03 627.1 214.89 627.3 214.74C627.74 214.42 628.17 214.09 628.59 213.76C628.77 213.62 628.95 213.48 629.13 213.34C629.71 212.87 630.27 212.39 630.8 211.89L630.82 211.87C631.35 211.38 631.84 210.88 632.33 210.38C632.48 210.22 632.63 210.06 632.77 209.9C632.96 209.69 633.17 209.48 633.36 209.27C633.48 209.13 633.59 208.98 633.71 208.84C633.91 208.6 634.1 208.37 634.29 208.13C634.55 207.8 634.81 207.46 635.05 207.12C635.23 206.88 635.4 206.64 635.57 206.39C635.81 206.04 636.04 205.68 636.26 205.32C636.41 205.08 636.56 204.84 636.7 204.6C636.92 204.21 637.13 203.82 637.33 203.43C637.44 203.21 637.57 202.99 637.67 202.76C637.69 202.71 637.72 202.66 637.75 202.61C637.99 202.1 638.2 201.59 638.4 201.08C638.45 200.96 638.49 200.84 638.54 200.72C638.76 200.13 638.97 199.53 639.14 198.92C639.14 198.9 639.15 198.87 639.16 198.85C639.27 198.47 639.37 198.08 639.46 197.69C639.51 197.46 639.56 197.23 639.6 197C639.61 196.92 639.63 196.85 639.65 196.77C639.76 196.16 639.85 195.55 639.91 194.93C639.91 194.84 639.93 194.74 639.94 194.65C639.98 194.18 640.01 193.72 640.03 193.24C640.03 193.04 640.03 192.85 640.03 192.65V169.11C640.03 169.78 640 170.44 639.94 171.1V171.09Z",
    fill: "url(#paint17_linear_4_152914)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M483.84 247.56C482.69 247.62 481.54 247.65 480.38 247.65C479.48 247.65 478.58 247.63 477.68 247.59C475.52 247.5 473.38 247.3 471.25 246.98C468.76 246.61 466.3 246.09 463.9 245.42C461.88 244.85 459.9 244.18 457.99 243.4L343.13 196.51C329.28 190.85 320.74 180.4 320.74 169.08V192.62C320.74 203.93 329.28 214.39 343.13 220.05L457.99 266.94C459.91 267.72 461.88 268.4 463.9 268.96C466.3 269.63 468.76 270.15 471.25 270.52C473.37 270.83 475.52 271.03 477.68 271.13C478.58 271.17 479.48 271.19 480.38 271.19C481.53 271.19 482.69 271.16 483.84 271.1C485.94 270.99 488.03 270.77 490.1 270.44V246.9C488.03 247.22 485.94 247.44 483.84 247.56Z",
    fill: "url(#paint18_linear_4_152914)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M480.39 0C488.12 0 495.85 1.41 502.78 4.24L617.64 51.13C631.49 56.79 640.03 67.24 640.03 78.56V172.35C640.03 183.66 631.49 194.12 617.64 199.78L502.78 246.67C495.85 249.5 488.12 250.91 480.39 250.91C472.66 250.91 464.93 249.5 458 246.67L343.14 199.78C329.29 194.12 320.75 183.67 320.75 172.35V78.56C320.75 67.25 329.29 56.79 343.14 51.13L457.99 4.24C464.92 1.41 472.65 0 480.38 0H480.39Z",
    fill: "url(#paint19_linear_4_152914)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M480.39 251.65C479.48 251.65 478.57 251.63 477.66 251.59C475.48 251.5 473.29 251.29 471.15 250.98C468.62 250.61 466.11 250.08 463.71 249.4C461.65 248.82 459.64 248.13 457.72 247.35L342.86 200.46C328.76 194.7 320 183.92 320 172.34H321.5C321.5 183.3 329.9 193.55 343.43 199.07L458.29 245.96C460.16 246.72 462.12 247.39 464.12 247.95C466.46 248.61 468.91 249.12 471.38 249.49C473.46 249.8 475.6 250 477.73 250.09C479.75 250.18 481.79 250.17 483.81 250.05C485.88 249.94 487.96 249.72 489.99 249.4C492.29 249.04 494.56 248.54 496.74 247.93C498.72 247.37 500.66 246.71 502.5 245.96L617.36 199.07C618.12 198.76 618.85 198.43 619.58 198.09L620.11 197.84C620.7 197.55 621.28 197.26 621.86 196.95L622.32 196.71C623.01 196.33 623.69 195.94 624.34 195.53L624.83 195.22C625.32 194.91 625.8 194.59 626.27 194.26C626.48 194.12 626.68 193.97 626.88 193.82C627.31 193.51 627.73 193.19 628.14 192.86L628.3 192.73C628.42 192.63 628.55 192.54 628.67 192.44C629.23 191.98 629.78 191.51 630.31 191.03C630.85 190.53 631.34 190.04 631.81 189.55C631.91 189.44 632.01 189.34 632.11 189.23L632.25 189.08C632.57 188.74 632.87 188.39 633.17 188.04C633.36 187.81 633.55 187.58 633.74 187.34C634 187.02 634.24 186.69 634.49 186.35C634.66 186.11 634.83 185.88 634.99 185.64C635.22 185.3 635.44 184.95 635.66 184.6L635.77 184.43C635.88 184.25 635.99 184.08 636.09 183.9C636.31 183.52 636.5 183.14 636.7 182.76L636.83 182.52C636.9 182.39 636.97 182.25 637.04 182.12C637.29 181.59 637.53 181.04 637.75 180.49L637.87 180.18C638.13 179.48 638.32 178.92 638.47 178.4C638.65 177.76 638.79 177.18 638.91 176.54L638.96 176.32C639.06 175.76 639.15 175.16 639.21 174.54L639.24 174.27C639.3 173.59 639.33 172.96 639.33 172.35H640.83C640.83 173 640.8 173.68 640.73 174.41L640.7 174.7C640.63 175.36 640.54 176 640.43 176.6L640.4 176.74C640.25 177.51 640.1 178.14 639.93 178.74C639.75 179.38 639.55 179.97 639.29 180.66L639.15 181.04C638.92 181.63 638.67 182.21 638.4 182.77C638.33 182.92 638.25 183.08 638.17 183.23L638.05 183.46C637.84 183.86 637.63 184.27 637.41 184.66C637.3 184.85 637.18 185.04 637.06 185.24L636.96 185.41C636.73 185.78 636.5 186.14 636.25 186.51C636.08 186.76 635.9 187 635.73 187.25C635.47 187.61 635.21 187.95 634.94 188.29C634.75 188.54 634.55 188.78 634.34 189.02C634.03 189.39 633.71 189.75 633.38 190.11L633.25 190.26C633.14 190.38 633.04 190.49 632.93 190.61C632.39 191.17 631.89 191.67 631.39 192.13C630.86 192.62 630.3 193.11 629.66 193.63C629.53 193.74 629.4 193.84 629.27 193.94L629.11 194.06C628.68 194.4 628.25 194.73 627.8 195.05C627.59 195.2 627.38 195.35 627.17 195.5C626.68 195.84 626.19 196.17 625.68 196.49L625.18 196.81C624.5 197.23 623.8 197.64 623.09 198.03L622.61 198.28C622.02 198.59 621.42 198.9 620.81 199.2L620.27 199.46C619.52 199.81 618.77 200.15 617.98 200.47L503.12 247.36C501.22 248.13 499.23 248.82 497.2 249.39C494.96 250.02 492.63 250.53 490.27 250.9C488.19 251.23 486.06 251.45 483.94 251.57C482.78 251.63 481.6 251.67 480.44 251.67L480.39 251.65Z",
    fill: "url(#paint20_linear_4_152914)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M463.39 82.6802V87.8502L462.46 88.2302V83.0602L463.39 82.6802Z",
    fill: "#93D1C2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M506.07 86.2202V91.3902L463.05 73.8302V68.6602L506.07 86.2202Z",
    fill: "#7DBDAE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M462.46 83.0601V88.2301L420.37 105.41V100.24L462.46 83.0601Z",
    fill: "#93D1C2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M480.39 63.01C482.65 63.01 484.91 63.42 486.93 64.24L523.42 79.14V142.3L506.07 149.38V86.21L463.04 68.64L473.85 64.23C475.87 63.41 478.13 63 480.39 63V63.01Z",
    fill: "url(#paint21_linear_4_152914)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M523.42 142.31V147.48L506.07 154.56V149.39L523.42 142.31Z",
    fill: "#93D1C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_152914",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 403,
    y: 150,
    width: 7,
    height: 15
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M409.56 159V164.17C405.52 162.52 403.01 159.46 403.01 156.16V150.99C403.01 154.29 405.52 157.35 409.56 159Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_152914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.56 159V164.17C405.52 162.52 403.01 159.46 403.01 156.16V150.99C403.01 154.29 405.52 157.35 409.56 159Z",
    fill: "#7DBDAE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4_152914",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 551,
    y: 151,
    width: 7,
    height: 14
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M557.76 151V156.17C557.76 159.46 555.26 162.53 551.23 164.18V159.01C555.26 157.36 557.76 154.29 557.76 151Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4_152914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.75 151.17V156.34C557.74 156.78 557.68 157.21 557.59 157.63V152.46C557.69 152.04 557.74 151.6 557.75 151.17Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.59 152.46V157.63C557.48 158.12 557.31 158.6 557.09 159.07V153.9C557.31 153.43 557.48 152.95 557.59 152.46Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.09 153.9V159.07C556.77 159.76 556.34 160.41 555.8 161.02V155.85C556.33 155.24 556.77 154.58 557.09 153.9Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.8 155.85V161.02C554.87 162.08 553.64 163.02 552.16 163.75V158.58C553.64 157.85 554.87 156.91 555.8 155.85Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.17 158.58V163.75C551.87 163.9 551.55 164.04 551.23 164.18V159.01C551.55 158.88 551.87 158.73 552.17 158.58Z",
    fill: "#93D1C2"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M489.06 156.33V161.5L480.4 165.05V159.88L489.06 156.33Z",
    fill: "#93D1C2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M480.4 89.6201L489.06 93.1601V156.33L480.4 159.88L471.72 156.33V93.1601L472.03 93.0301L480.4 89.6201Z",
    fill: "url(#paint22_linear_4_152914)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M480.4 159.88V165.05L471.72 161.5V156.33L480.4 159.88Z",
    fill: "#7DBDAE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M446.04 75.6001L463.39 82.6801L462.46 83.0601L420.37 100.24V163.42L409.56 159.01C405.52 157.36 403.01 154.3 403.01 151V98.5001C403.01 95.2101 405.52 92.1401 409.56 90.4901L446.04 75.6001Z",
    fill: "url(#paint23_linear_4_152914)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M420.37 163.42V168.59L409.56 164.17V159L420.37 163.42Z",
    fill: "#7DBDAE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M514.74 173.9V179.07L497.38 171.98V166.81L514.74 173.9Z",
    fill: "#7DBDAE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M551.22 159.01V164.18L514.74 179.07V173.9L551.22 159.01Z",
    fill: "#93D1C2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M540.41 86.0801L551.22 90.4901C555.26 92.1401 557.76 95.2101 557.76 98.5001V151C557.76 154.29 555.26 157.36 551.23 159.01L514.75 173.91L497.39 166.82L498.33 166.44L540.42 149.26V86.0801H540.41Z",
    fill: "url(#paint24_linear_4_152914)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M473.86 185.26V190.43L437.37 175.52V170.35L473.86 185.26Z",
    fill: "#7DBDAE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M497.74 180.85V186.02L486.93 190.43V185.26L497.74 180.85Z",
    fill: "#93D1C2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M454.72 100.1V163.28L497.75 180.85L486.94 185.26C484.96 186.06 482.7 186.49 480.4 186.49C478.1 186.49 475.83 186.06 473.86 185.25L437.37 170.35V107.18L454.72 100.1Z",
    fill: "url(#paint25_linear_4_152914)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4_152914",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 473,
    y: 185,
    width: 14,
    height: 7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M486.93 185.26V190.43C484.95 191.23 482.69 191.66 480.39 191.66C478.09 191.66 475.82 191.23 473.85 190.42V185.25C475.82 186.06 478.09 186.49 480.39 186.49C482.69 186.49 484.95 186.06 486.93 185.26Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4_152914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.93 185.26V190.43C486.39 190.65 485.83 190.84 485.25 191V185.83C485.83 185.67 486.39 185.48 486.93 185.26Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.26 185.83V191C484.6 191.18 483.93 191.33 483.24 191.44V186.27C483.93 186.16 484.61 186.01 485.26 185.83Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.24 186.27V191.44C482.64 191.53 482.02 191.6 481.4 191.63V186.46C482.02 186.43 482.63 186.36 483.24 186.27Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.4 186.47V191.64C481.07 191.66 480.73 191.67 480.4 191.67C480.14 191.67 479.87 191.67 479.61 191.65V186.48C479.87 186.49 480.13 186.5 480.4 186.5C480.74 186.5 481.07 186.5 481.4 186.47Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.61 186.48V191.65C478.98 191.62 478.35 191.56 477.73 191.47V186.3C478.35 186.39 478.98 186.45 479.61 186.48Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.58 185.84C474.99 185.67 474.41 185.48 473.86 185.25V190.42C474.41 190.65 474.99 190.84 475.58 191.01C476.28 191.2 476.99 191.36 477.73 191.46V186.29C477 186.18 476.28 186.03 475.58 185.83V185.84Z",
    fill: "url(#paint26_linear_4_152914)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4_152914",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(476.35 322.37) scale(223.51 223.51)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#315A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#96B6B8",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF5F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_152914",
    x1: 616.72,
    y1: 137.24,
    x2: 919.72,
    y2: 137.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_152914",
    x1: 613.15,
    y1: 268.86,
    x2: 1000.28,
    y2: 268.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_152914",
    x1: -0.0000782617,
    y1: 215.11,
    x2: 918.75,
    y2: 215.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_152914",
    x1: -0.0000782617,
    y1: 165.05,
    x2: 918.75,
    y2: 165.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_152914",
    x1: 0,
    y1: 159.27,
    x2: 321.75,
    y2: 159.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_152914",
    x1: 0,
    y1: 151,
    x2: 321,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_152914",
    x1: 0,
    y1: 155.99,
    x2: 320,
    y2: 155.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_152914",
    x1: 0,
    y1: 257.15,
    x2: 320.67,
    y2: 257.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_152914",
    x1: 489.95,
    y1: 311.58,
    x2: 640.04,
    y2: 311.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#093640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#08313B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_152914",
    x1: 320.73,
    y1: 311.96,
    x2: 490.1,
    y2: 311.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0B3B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#104854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#23788C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#093640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_152914",
    x1: 480.39,
    y1: 92.8601,
    x2: 480.39,
    y2: 337.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185361",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_152914",
    x1: 319.98,
    y1: 303.81,
    x2: 640.79,
    y2: 303.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093640",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0C3D48",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#16515F",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1E6272",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#257082",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A7B8E",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2E8397",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#30879C",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31899E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#30879B",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2D8194",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#287689",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#216879",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#185664",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0D404B",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093640",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_152914",
    x1: 489.93,
    y1: 265.68,
    x2: 640.04,
    y2: 265.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5468D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4B5FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_152914",
    x1: 320.73,
    y1: 266.05,
    x2: 490.1,
    y2: 266.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#576BD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6C7EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B5C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#586CDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_152914",
    x1: 480.39,
    y1: 46.9502,
    x2: 480.39,
    y2: 291.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#788AF0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C70E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_152914",
    x1: 319.98,
    y1: 257.91,
    x2: 640.79,
    y2: 257.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C70E6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6175E7",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7284EC",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8292F0",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#909EF4",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9BA9F7",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A4B1FA",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ACB7FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B1BCFD",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B4BFFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B5C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B3BEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#AFBAFD",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A8B4FB",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#9EABF8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#91A0F5",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8191F0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6F81EB",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C70E6",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_152914",
    x1: 489.99,
    y1: 219.77,
    x2: 640.04,
    y2: 219.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98E0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8DDBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79D1BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_152914",
    x1: 320.73,
    y1: 220.15,
    x2: 490.1,
    y2: 220.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82D1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#93DFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0EBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C0F0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#98E0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_152914",
    x1: 480.39,
    y1: 1.05,
    x2: 480.39,
    y2: 245.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBF0E3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#AFECDD",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A9EBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_152914",
    x1: 319.98,
    y1: 212,
    x2: 640.79,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82D1C0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#92D7C8",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A0DDCF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ACE2D6",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6E6DB",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BFEAE0",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C5ECE3",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CAEEE6",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CDEFE7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CEF0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CDEFE7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CAEEE6",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5EDE4",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BFEBE1",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B7E9DD",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ACE6D8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1E2D3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98E0CF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_152914",
    x1: 475.99,
    y1: 53.78,
    x2: 543.26,
    y2: 158.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E3FBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_152914",
    x1: 446.87,
    y1: 72.4301,
    x2: 514.14,
    y2: 177.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4_152914",
    x1: 416.56,
    y1: 91.8601,
    x2: 483.83,
    y2: 196.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4_152914",
    x1: 477.18,
    y1: 53.0201,
    x2: 544.45,
    y2: 158.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4_152914",
    x1: 417.76,
    y1: 91.0901,
    x2: 485.03,
    y2: 196.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4_152914",
    x1: 473.86,
    y1: 188.36,
    x2: 477.73,
    y2: 188.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DBDAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D1C2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_152914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 452,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleSystemBgImage);
export default __webpack_public_path__ + "static/media/role_system_bg_image.18a82c5ed620fc5e83fa2845ee730e62.svg";
export { ForwardRef as ReactComponent };